'use client'

import Link from 'next/link'
import type { CustomLinkProps } from '@/components/DefaultLink'
import type { CustomFormProps } from '@/components/DefaultForm'

export const DefaultNextLink = (props: CustomLinkProps) =>
  props.useRouterLink ? <Link {...props} /> : <a {...props} />

export const DefaultNextForm = (props: CustomFormProps) => <form {...props} />
